import React from "react";

interface Props {
  input: AudioNode;
}

export default class Visualizer extends React.Component<Props> {
  private _animationFrameHandle: number;
  private analyser: AnalyserNode;
  private buffer: Uint8Array;
  gain: GainNode;

  constructor(props: Props) {
    super(props);

    const context = this.props.input.context;
    this.gain = context.createGain();
    this.gain.gain.value = 3;
    this.props.input.connect(this.gain);

    this.analyser = context.createAnalyser();
    this.analyser.fftSize = 2048;
    this.buffer = new Uint8Array(this.analyser.frequencyBinCount);
    this.gain.connect(this.analyser);
  }

  componentDidMount() {
    this._animationFrameHandle = requestAnimationFrame(this.onAnimationFrame);
  }

  componentWillUnmount() {
    this.props.input.disconnect(this.analyser);
    cancelAnimationFrame(this._animationFrameHandle);
  }

  onAnimationFrame = () => {
    this.forceUpdate();
    this._animationFrameHandle = requestAnimationFrame(this.onAnimationFrame);
  };

  render() {
    this.analyser.getByteTimeDomainData(this.buffer);
    const points = Array.from(this.buffer)
      .map((value, x) => {
        const v = value / 256 - 0.5;
        const midpoint = this.buffer.length / 2;
        const distFromEdge = 1.0 - Math.abs(midpoint - x) / midpoint;
        const d = distFromEdge ** 0.7;
        const y = 0.5 - d * v;
        return [x, y].join(",");
      })
      .join(" ");
    return (
      <svg
        preserveAspectRatio="none"
        viewBox={`0 0 ${this.buffer.length} 1`}
        style={{ width: "100%", height: "200px" }}
      >
        <polyline
          stroke="white"
          fill="none"
          strokeWidth="0.01"
          points={points}
        />
      </svg>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Visualizer.tsx